<template>
  <div class="imgBoxDialog  absolute_center"
    :class="{_boxBg_dark_secondLevel:styleType == 'typeDark',_boxBg_green_secondLevel:styleType == 'typeGreen', _boxBg_blue_secondLevel:styleType == 'typeBlue', _boxBg_strong_secondLevel: styleType == 'typeStrong'}">
    <div class="selfClose_btn" @click="close()"></div>
    <div class="_boxTitle">图片详情</div>
    <div class="_yellowLine"></div>
    <div class="btns">
      <div class="text" style="color: #f5a623" @click="turnLeft">点击图片进行旋转</div>
    </div>
    <div class="_innerBox" id="img_src">
      <el-image
        style="width: 100%"
        :src="imgurl"
        :fit="scale-down"
        :preview-src-list="srcList">
      </el-image>
<!--      <img id="img_src" :src="imgurl">-->
    </div>

  </div>
</template>

<script>
export default {
  props: ["globalInstance", "imgurl"],
  setup(props) {
    const imgurl = props.imgurl;
    const globalInstance = props.globalInstance;
    return { globalInstance, imgurl };
  },
  data() {
    return {
      rotate: 0,
      srcList: [],
    };
  },
  created() {},
  mounted() {
    this.rotate = 0;
    this.srcList = [this.imgurl]
  },
  computed: {
    styleType() {
      return this.globalInstance.$store.state.styleType;
    },
  },
  watch: {},
  methods: {
    close() {
      let that = this._.appContext.app;
      this.$popup.close2(that);
    },
    turnLeft() {
      this.rotate = this.rotate - 90;
      $("#img_src").css('transform', `rotate(${this.rotate}deg)`)
      console.log($("#img_src").height(), $("#img_src").width())
    },
    turnRight() {
      this.rotate = this.rotate + 90;
      $("#img_src").css('transform', `rotate(${this.rotate}deg)`)
      console.log($("#img_src").height(), $("#img_src").width())
    }
  },
};
</script>

<style lang="scss" scoped>
.imgBoxDialog {
  overflow: hidden;
  ._innerBox {
    //display: flex;
    align-items: center;
    overflow: auto;
    width:1000px;
    height:600px;
    margin: 80px auto 0;
    img {
      width: 100%;
      transition: all linear .5s;
    }
  }
  .btns {
    height: 50px;
    display: flex;
    position: relative;
    z-index:999;
    justify-content: center;
    font-size: 26px;
    font-weight: 500;
    cursor: pointer;
  }
}
</style>
